export const getTranslatedAttributeName = (backingField, t) => {
    var key = `attribute_${toBackingField(backingField)}`;
    var translation = t(`attributes:::${key}`);
    return key == translation ? backingField : translation;
};

export const getTranslatedAttributeValue = (backingField, value, t) => {
    const cleanedUpBackingField = toBackingField(backingField);

    // Sometimes saved searches have the color attribute values as title case ("Red" instead of "red"). This is a work around.
    if (cleanedUpBackingField === 'color') {
        value = value.toLowerCase();
    }

    var key = `attribute_af-${cleanedUpBackingField}_${value}`;
    var translation = t(`attributes:::${key}`);
    return key == translation ? value : translation;
};

const toBackingField = backingField => {
    return backingField.toLowerCase().replace('af-', '');
};

export const addTextAndReSort = (
    backingField,
    t,
    shouldTranslateValues,
    options
) => {
    return addText(backingField, t, shouldTranslateValues, options).sort(
        orderBySortOrderThenByAttributeName
    );
};

export const addText = (backingField, t, shouldTranslateValues, options) =>
    options.map(option => {
        const text = shouldTranslateValues
            ? getTranslatedAttributeValue(backingField, option.value, t)
            : option.value;
        return { ...option, text };
    });

const orderBySortOrderThenByAttributeName = (a, b) => {
    // Sort by sortOrder
    // If the first item has a higher number, move it down
    // If the first item has a lower number, move it up
    if (a.sortOrder > b.sortOrder) return 1;
    if (a.sortOrder < b.sortOrder) return -1;

    // If the sortOrder number is the same between both items, sort alphabetically
    // If the first item comes first in the alphabet, move it up
    // Otherwise move it down
    if (a.text > b.text) return 1;
    if (a.text < b.text) return -1;
};
